import * as React from 'react'
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js'
import styled from 'styled-components'
import { fetchFromShopware, updateToken } from 'hooks/account/utils'
import useAccount from 'hooks/account/useAccount/useAccount'
import config from 'config'
import * as events from '../events'
import { theme } from 'containers/GlobalStyle'

const currency = config.i18n.currency_ISO

type Props = {
  'data-cy-state'?: string
}

export default function PaypalButton(props: Props) {
  const [{ options }, dispatch] = usePayPalScriptReducer() as [
    { options: any },
    React.Dispatch<{ type: string; value: object }>
  ]
  const account = useAccount()

  React.useEffect(() => {
    dispatch({
      type: 'resetOptions',
      value: {
        ...options,
        currency: currency
      }
    })
  }, [currency])

  return (
    <Wrapper className="PaypalButton" data-cy-state={props['data-cy-state']}>
      {/* eslint-disable-next-line @kaminrunde/firescout/onclick-needs-handle */}
      <PayPalButtons
        style={{
          layout: 'horizontal',
          height: 40,
          tagline: false,
          label: 'checkout',
          color: 'gold'
        }}
        disabled={false}
        forceReRender={[currency, account.cart.data.totalPrice]}
        fundingSource={undefined}
        onClick={() => {
          events.buttonClick()
        }}
        createOrder={async () => {
          return fetchFromShopware({
            method: 'POST',
            url: '/paypal/express/create-order'
          }).then(([result, status]) => {
            if (status === 200) {
              return result.token
            } else throw new Error('failed')
          })
        }}
        onApprove={(ctx) => {
          return fetchFromShopware({
            method: 'POST',
            url: '/paypal/express/prepare-checkout',
            body: {
              token: ctx.orderID
            }
          }).then(([, , token]) => {
            updateToken(token)
            sessionStorage.setItem(
              'paypal-express',
              JSON.stringify({
                price: account.cart.data.totalPrice,
                po: ctx.orderID
              })
            )
            events.paymentApproved()
            if (location.href.includes(location.origin + '/' + config.locale)) {
              window.location.href =
                location.origin +
                '/' +
                config.locale +
                '/checkout/overview/?po=' +
                ctx.orderID
            } else {
              window.location.href =
                location.origin + '/checkout/overview/?po=' + ctx.orderID
            }
          })
        }}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  z-index: ${theme.zIndex
    .theme_molecules_account_cartsummary_paypalexpress_paypalbutton};
  min-height: 40px;
  position: relative;

  > .overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: ${theme.zIndex
      .theme_molecules_account_cartsummary_paypalexpress_paypalbutton_Overlay};
  }
`
